import { useBaseCreate } from "../../base/hooks/useBaseCreate";
import { CreatePayment } from "../schema/CreatePaymentSchema";
import { CreatePaymentResponse, CreatePaymentResponseSchema } from "../response/CreatePaymentResponse";

const API_VERSION = "v3";

export default function useCreatePayment() {
    return useBaseCreate<CreatePayment, CreatePaymentResponse>({
        endpoint: `${API_VERSION}/payment`,
        schema: CreatePaymentResponseSchema,
        contentType: "application/json",
        onSuccess: (data) => data,
        onError: (error) => {
            console.error("Error creating user:", error);
            throw error;
        },
    });
}